import loaded from '@/scripts/helpers/loaded';
function onElementLoadedProductReviews(selector, callback) {
    let interval = setInterval(function () {
        if (document.querySelectorAll(selector).length) {
            clearInterval(interval);
            callback();
        }
    }, 100);
}

// Helper function for smooth scrolling
function smoothScrollTo(element, duration = 500, offset = 0) {
    const targetPosition = element.offsetTop - offset;
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
}

loaded(() => {
    onElementLoadedProductReviews(`.stamped-summary-actions-newreview`, function () {
        let scrollReviewId = 'tab-reviews';
        let extraPadding = 100;
        const addReviewButton = document.querySelector('.stamped-summary-actions-newreview');
        const reviewForm = document.querySelector('.new-review-form');
        const addQuestionsButton = document.querySelector('.stamped-summary-actions-newquestion');
        const paginationLinks = document.querySelectorAll('.stamped-pagination a');
        const summaryRatingBar = document.querySelector('.summary-rating-bar');

        if (window.innerWidth > 1024) {
            scrollReviewId = 'reviews__tab';
            extraPadding = 0;
        }

        if (addReviewButton) {
            addReviewButton.removeAttribute('onclick');
            addReviewButton.addEventListener('click', function () {
                const questionForm = document.querySelector('#new-question-form');
                const targetElement = document.querySelector(`#${scrollReviewId}`);
                
                if (reviewForm) {
                    const isVisible = reviewForm.style.display !== 'none' && 
                                    window.getComputedStyle(reviewForm).display !== 'none';
                    
                    if (isVisible) {
                        reviewForm.style.display = 'none';
                    } else {
                        reviewForm.style.display = 'block';
                        if (questionForm) questionForm.style.display = 'none';
                    }
                }
                
                if (targetElement) {
                    smoothScrollTo(targetElement, 500, extraPadding);
                }
            });
        }

        if (addQuestionsButton) {
            addQuestionsButton.removeAttribute('onclick');
            addQuestionsButton.addEventListener('click', function () {
                const questionForm = document.querySelector('#new-question-form');
                const targetElement = document.querySelector(`#${scrollReviewId}`);
                
                if (questionForm) {
                    const isVisible = questionForm.style.display !== 'none' && 
                                    window.getComputedStyle(questionForm).display !== 'none';
                    
                    if (isVisible) {
                        questionForm.style.display = 'none';
                    } else {
                        if (reviewForm) reviewForm.style.display = 'none';
                        questionForm.style.display = 'block';
                    }
                }
                
                if (targetElement) {
                    smoothScrollTo(targetElement, 500, extraPadding);
                }
            });
        }

        if (summaryRatingBar) {
            summaryRatingBar.addEventListener('click', function () {
                setTimeout(function () {
                    const targetElement = document.querySelector(`#${scrollReviewId}`);
                    if (targetElement) {
                        smoothScrollTo(targetElement, 100);
                    }
                }, 1000);
            });
        }

        paginationLinks.forEach(function(link) {
            link.addEventListener('click', function () {
                const targetElement = document.querySelector(`#${scrollReviewId}`);
                if (targetElement) {
                    smoothScrollTo(targetElement, 100);
                }
            });
        });

        document.querySelectorAll('.item--product__tabs').forEach(function(tab) {
            tab.addEventListener('click', function () {
                const emptyState = document.querySelector('.stamped-empty-state');
                if (emptyState && window.getComputedStyle(emptyState).display !== 'none') {
                    const caption = document.querySelector('.stamped-summary-caption-1');
                    const actions = document.querySelector('.stamped-summary-actions');
                    
                    if (caption) {
                        caption.style.opacity = '0';
                        caption.style.position = 'absolute';
                    }
                    if (actions) {
                        actions.style.justifyContent = 'center';
                    }
                }
            });
        });
    });
});
